/** 底栏公司主体与备案信息（icp / police 填写展示文案，空串则显示「待补充」） */
export const SITE_FOOTER = {
  companyName: "上海魔法向量人工智能技术有限公司",
  /** 展示在「ICP 许可证：」后，如 沪ICP备12345678号-1 */
  icpLabel: "沪ICP备2026025499号-1",
  /** 工信部查询入口（点击整行 ICP 时可选） */
  icpQueryUrl: "https://beian.miit.gov.cn/",
  /** 展示在「公安网备：」后 */
  policeLabel: "" as string,
  /** 网安公开展示用链接 */
  policeQueryUrl: "http://www.beian.gov.cn/portal/registerSystemInfo",
} as const;
